import axios from 'axios'

import {
  requestErrorInterceptor,
  requestInterceptor,
  errorInterceptor,
  responseInterceptor
} from './interceptors'

export default defineNuxtPlugin(() => {
  const { public: { NUXT_API_URL } } = useRuntimeConfig()
  const instance = axios.create({
    baseURL: NUXT_API_URL
  })

  instance.interceptors.response.use(
    res => responseInterceptor(res),
    err => errorInterceptor(err)
  )

  instance.interceptors.request.use(requestInterceptor, requestErrorInterceptor)

  return {
    provide: {
      apiClient: instance
    }
  }
})
